<ng-container *ngIf="step">
    <p *ngIf="content" class="content">{{ content }}</p>
    <h2 class="text-center" *ngIf="!content">
        Thank you for taking the time to complete this form.<br><br> A Sales Representative will be with you shortly to assist you further.<br><br> You may safely exit this page.
    </h2>
</ng-container>
